import { useTranslation } from 'react-i18next';
import { useMeQuery } from '@platform/state/api';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { matchesShow } from './inboxFilters';
import { InboxRow } from './InboxRow';
import { useInbox } from './useInbox';
import { useInboxParams } from './useInboxParams';
import { useOpenInboxEntry } from './useOpenInboxEntry';
import './inbox.css';

const SHOWN = 100;

/**
 * «Мої вхідні» (patterns/notifications-inbox, прототип v4 G:L2558–2596): «Мої вхідні · фільтр», опис, «Позначити все прочитаним»; картка
 * рядків (до 100, найновіші першими) за фільтром «Показати» й робочим простором з лівого меню вхідних; порожньо — «Тут порожньо — ви все
 * опрацювали.».
 */
export function InboxPage() {
  const { t } = useTranslation();
  const { ws } = useWorkspaceParams();
  const { data: me } = useMeQuery();
  const inbox = useInbox();
  const { show, space } = useInboxParams();
  const open = useOpenInboxEntry(ws, inbox.setRead);
  const shown = inbox.entries.filter((e) => matchesShow(e, show) && (!space || e.workspaceId === space)).slice(0, SHOWN);
  const wsName = (id: string | null, fallback: string | null) => me?.workspaces.find((w) => w.id === id)?.name ?? fallback ?? t('shell.platform');
  return (
    <div className="ib-page">
      <div className="ib-head">
        <div className="ib-head__text">
          <h1>{t('inboxPage.heading', { filter: t(`inboxPage.filters.${show}`) })}</h1>
          <span className="muted">{t('inboxPage.sub')}</span>
        </div>
        <div role="toolbar" aria-label={t('inboxPage.actions')} className="ib-toolbar">
          <button type="button" className="ib-tbtn" onClick={inbox.markAllRead}>{t('inboxPage.markAll')}</button>
        </div>
      </div>
      <div className="ib-list">
        {shown.map((e) => (
          <InboxRow key={e.key} entry={e} workspaceName={wsName(e.workspaceId, e.workspaceName)} onOpen={open} onToggle={(x) => inbox.setRead([x], !x.read)} />
        ))}
        {!inbox.loading && !shown.length && <div className="ib-empty">{t('inboxPage.empty')}</div>}
      </div>
    </div>
  );
}
